import React, { useContext, createContext, useEffect, useMemo } from "react";
import create from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import produce from "immer";
import PropTypes from "prop-types";

export function getStore(storeId) {
  return window.stores[storeId];
}

export function createStore(storeId, stateFunc) {
  window.stores = window.stores || {};
  if (window.stores[storeId]) return window.stores[storeId];
  const store = create(subscribeWithSelector(stateFunc));
  window.stores[storeId] = store;
  return window.stores[storeId];
}

export function createStoreWithImmer(storeId, storeCreator) {
  return createStore(storeId, (originalSet, originalGet) =>
    storeCreator((fn) => originalSet(produce(fn)), originalGet)
  );
}

const Context = createContext();

export function useStore() {
  return useContext(Context);
}

export function Store({ uId, clearStoreOnUnMount = true, ...restProps }) {
  useEffect(
    function onUnmount() {
      return () => clearStoreOnUnMount && cleanUpStore(uId);
    },
    [uId, clearStoreOnUnMount]
  );

  let state = useMemo(
    function getUserState() {
      const useStateStore = getStore(uId);
      return { useStateStore };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [uId]
  );
  return <Context.Provider value={state} {...restProps} />;
}

Store.propTypes = {
  uId: PropTypes.string,
  clearStoreOnUnMount: PropTypes.bool
};

export function cleanUpStore(uId) {
  // eslint-disable-next-line no-unused-vars
  const useStateStore = getStore(uId);
  useStateStore?.getState()?.reset?.();
  Reflect.deleteProperty(window.stores, uId);
}
